import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M16.182 18.042H3.72C3.129 18.042 2.619 17.622 2.509 17.043L2.479 7.28605C2.479 6.60405 3.032 6.05005 3.712 6.05005H19.431C20.566 6.05005 21.489 6.97505 21.489 8.11105V12.74C21.489 13.295 21.261 13.832 20.864 14.213L17.633 17.447C17.244 17.831 16.729 18.042 16.182 18.042ZM3.713 7.04905C3.587 7.04905 3.48 7.15705 3.48 7.28405L3.5 16.948C3.512 16.964 3.608 17.042 3.72 17.042H16.181C16.463 17.042 16.729 16.934 16.927 16.737L20.163 13.498C20.372 13.297 20.488 13.023 20.488 12.739V8.11005C20.488 7.52505 20.013 7.04905 19.43 7.04905H3.713V7.04905Z"
      fill="currentColor"
    />
    <path
      d="M13.019 9.01501V14.99H5.61597V9.01501H13.019V9.01501ZM13.019 8.01501H5.61597C5.06597 8.01501 4.61597 8.46501 4.61597 9.01501V14.99C4.61597 15.54 5.06597 15.99 5.61597 15.99H13.019C13.569 15.99 14.019 15.54 14.019 14.99V9.01501C14.019 8.46501 13.569 8.01501 13.019 8.01501V8.01501Z"
      fill="currentColor"
    />
    <path d="M7.125 9.01501H8.125V15.5H7.125V9.01501Z" fill="currentColor" />
    <path d="M5.61597 10H7.62497V11H5.61597V10Z" fill="currentColor" />
    <path d="M5.61597 13.062H7.62497V14.062H5.61597V13.062Z" fill="currentColor" />
    <path d="M10.4951 9.01501H11.4951V15.5H10.4951V9.01501Z" fill="currentColor" />
    <path d="M10.9951 10H13.0051V11H10.9951V10Z" fill="currentColor" />
    <path d="M10.9951 13.062H13.0051V14.062H10.9951V13.062Z" fill="currentColor" />
  </>
);

const Icon = createSvgIcon(svg, 'SimCard');

export default Icon;
